import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ScrollArea from 'react-scrollbar';
import SVGInline from "react-svg-inline"
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import Modal from 'react-modal';

// components
import { PriceOption } from '../../ScreenElements/PriceOption';
import { PriceOptionWeb } from '../../ScreenElements/PriceOptionWeb';

// utils
import { isMobile } from '../../../utils';

// svgs
import closeCrossSVG from '../../inlineSVGs/closeCrossSVG';

// styles
import './styles.css';

const TYPE_FREE = 'free';
const TYPE_MID  = 'mid';
const TYPE_HIGH = 'high';
const TYPE_HUGE = 'huge';

// TODO: old! not in use in new Hebrew version - remove this shit
class PayingMethods extends Component {

    componentWillReceiveProps(nextProps) {
        if (!this.props.isModalOpen && nextProps.isModalOpen) {
            setTimeout(() => {
                disableBodyScroll(document.body);
            }, 200)

        } else if (this.props.isModalOpen && !nextProps.isModalOpen) {
            clearAllBodyScrollLocks();
        }
    }

    getPrices(range) {
        if (!this.props.datatypes || !this.props.pin || !this.props.pin.type) return null;

        const cat = this.props.datatypes.categories[this.props.pin.type].filter(c => c.name === (this.props.pin.category || this.props.pin.iWeAre));

        return cat[0] && cat[0].prices[range];
    }

    getBounce(range) {
        if (!this.props.datatypes || !this.props.pin || !this.props.pin.type) return null;

        const cat = this.props.datatypes.categories[this.props.pin.type].filter(c => c.name === this.props.pin.category);
        return cat[0] && cat[0].bounce[range];
    }

    addSelectedHighlightClass(enroll) {
        // TODO: at this point just return without adding selected style - because there is none....
        return null;
        // if (!this.props.pin || !this.props.pin.subscription) return null;
        //
        // if (this.props.pin.subscription.temp) return null;
        //
        // if (enroll === this.props.pin.subscription.enrolType) {
        //     return 'selected'
        // }
        //
        // return '';
    }

    renderSelected(enroll) {
        // TODO: at this point just return without adding selected style - because there is none....
        return null;
        // if (!this.props.pin || !this.props.pin.subscription) return null;
        //
        // if (this.props.pin.subscription.temp) return null;
        //
        // if (enroll === this.props.pin.subscription.enrolType) {
        //     return (
        //         <div className="selected-header">
        //             <p className="selected-text">Your current posting method</p>
        //             <div className="line" />
        //         </div>
        //     )
        // }
        //
        // return null;
    }

    renderPriceOptionFree(header, label, type) {
        if (isMobile()) {
            return (
                <PriceOption
                    header={header}
                    label={label}
                    type={type}
                    service={this.props.service}
                />
            )
        }

        return (
            <PriceOptionWeb
                header={header}
                label={label}
                type={type}
                service={this.props.service}
            />
        )
    }

    renderPriceOption(header, label, type) {
        if (isMobile()) {
            return (
                <PriceOption
                    header={header}
                    label={label}
                    type={type}
                    price={this.getPrices(type)}
                    time="/  Month"
                    service={this.props.service}
                    bounce={this.getBounce(type)}
                />
            )
        }

        return (
            <PriceOptionWeb
                header={header}
                label={label}
                type={type}
                price={this.getPrices(type)}
                time="/  Month"
                service={this.props.service}
                bounce={this.getBounce(type)}
            />
        )
    }

    renderFreePriceOption() {
        // const freeUserPins = this.props.userPins && this.props.userPins.filter(p => p.subscription && p.subscription.enrolType === TYPE_FREE) || [];
        // if (freeUserPins.length >= 2) return null; // TODO: free user pins limit should be dynamic from admin settings

        return (
            <div className={`option-wrapper ${this.addSelectedHighlightClass(TYPE_FREE)}`}>
                {this.renderSelected(TYPE_FREE)}
                {this.renderPriceOptionFree('BASIC', 'BABY MUSICIAN', TYPE_FREE)}
            </div>
        )
    }

    render() {
        return (
            <div>
                <Modal
                    isOpen={this.props.isModalOpen}
                    contentLabel="Paying Methods"
                    className="modal-wrapper paying-methods-wrapper"
                    style={{overlay: {
                            backgroundColor: 'rgba(0, 0, 0, 0.75)'
                        }}}
                >
                    <div onClick={this.props.closeModal} >
                        <SVGInline className="close-button" svg={closeCrossSVG} component="i"/>
                    </div>
                    <ScrollArea speed={0.8}
                                className={`area`}
                                horizontal={false}
                    >
                        <div className="content">
                            <div className="title">
                                <p></p>
                            </div>
                            <div className={`cards-wrapper ${!isMobile() ? 'web' : 'mobile'}`}>
                                {this.renderFreePriceOption()}
                                <div className={`option-wrapper ${this.addSelectedHighlightClass(TYPE_MID)}`}>
                                    {this.renderSelected(TYPE_MID)}
                                    {this.renderPriceOption('PUSH', 'MUSICIAN', TYPE_MID)}
                                </div>
                                <div className={`option-wrapper ${this.addSelectedHighlightClass(TYPE_HIGH)}`}>
                                    {this.renderSelected(TYPE_HIGH)}
                                    {this.renderPriceOption('RULE', 'BUSINESS', TYPE_HIGH)}
                                </div>
                                <div className={`option-wrapper ${this.addSelectedHighlightClass('high')}`}>
                                    {this.renderSelected(TYPE_HUGE)}
                                    {this.renderPriceOption('SUPER MUGICS', 'ENTERPRISE', TYPE_HUGE)}
                                </div>
                            </div>
                        </div>
                    </ScrollArea>
                </Modal>
            </div>
        )
    }
}

PayingMethods.propTypes = {
    isModalOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    service: PropTypes.string,
    pin: PropTypes.object,
    datatypes: PropTypes.object,
    userPins: PropTypes.array
};

export default PayingMethods;



// WEBPACK FOOTER //
// ./src/Components/Modals/PayingMethods/PayingMethods.js